// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.duplicateError {
  font-size: 11px;
  color: red;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/shared/domain-data/manufacturer-type-dialog/manufacturer-type-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,UAAA;AACF","sourcesContent":[".duplicateError {\n  font-size: 11px;\n  color: red;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
